"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dynatraceReporter_1 = require("./utils/dynatraceReporter");
const types_1 = require("./utils/types");
class ReporterDynatrace {
    constructor(config) {
        this.config = config;
        this.logger = console;
        this.timedMetricActionsMap = new Map();
        this.dynatraceSDK = (0, dynatraceReporter_1.createDynatraceInstance)();
    }
    initialize(initializer) {
        if ((0, dynatraceReporter_1.validateInitialization)(this.config, initializer)) {
            this.dynatraceSDK.setLoggingCallbacks({
                warning: message => this.logger.warn(message),
                error: message => this.logger.error(message),
            });
            if ((0, dynatraceReporter_1.getCurrentState)(this.dynatraceSDK) === 0 /* SDKState.ACTIVE */) {
                this.logger.info('Dynatrace SDK initialized');
            }
        }
    }
    log(key, value, logLevel) {
        this.logger[logLevel](`${key}: ${value}`);
    }
    exception(exception, logSeverityLevel) {
        this.logger[logSeverityLevel](exception.message, exception);
        this.dynatraceSDK.addCustomRequestAttribute(logSeverityLevel.toString(), exception.message);
    }
    recordBreadcrumb(breadCrumb) {
        const action = (0, dynatraceReporter_1.traceIncomingRemoteCall)(this.dynatraceSDK, {
            serviceMethod: breadCrumb.screenName,
            serviceName: 'Breadcrumb',
            serviceEndpoint: 'BreadcrumbEndpoint',
        });
        action.end();
    }
    setUserData(user) {
        this.dynatraceSDK.addCustomRequestAttribute('userId', user.userId);
    }
    startTimedMetric(timedMetric, overrideTimedMetric) {
        return this.startTimedMetricWithParent(timedMetric, overrideTimedMetric);
    }
    startTimedMetricWithParent(timedMetric, overrideTimedMetric, attachToParent) {
        (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.STARTING, timedMetric);
        if (overrideTimedMetric || !this.timedMetricActionsMap.has(timedMetric.eventName)) {
            if (overrideTimedMetric)
                this.finishTimedMetric(timedMetric, true);
            const action = (0, dynatraceReporter_1.traceOutgoingRemoteCall)(this.dynatraceSDK, {
                serviceMethod: timedMetric.eventName,
                serviceName: 'TimedMetric',
                serviceEndpoint: 'TimedMetricEndpoint',
                host: this.config.collectorUrl,
            });
            this.timedMetricActionsMap.set(timedMetric.eventName, action);
            (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.STARTED, timedMetric, attachToParent);
        }
        return !!this.timedMetricActionsMap.get(timedMetric.eventName);
    }
    stopTimedMetric(timedMetric) {
        (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.STOPPED, timedMetric);
        return this.finishTimedMetric(timedMetric, false);
    }
    cancelTimedMetric(timedMetric) {
        (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.CANCELLED, timedMetric);
        return this.finishTimedMetric(timedMetric, true);
    }
    finishTimedMetric(timedMetric, isCanceled) {
        (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.FINISHING, timedMetric);
        const action = this.timedMetricActionsMap.get(timedMetric.eventName);
        if (action) {
            if (isCanceled)
                action.error(new Error('Canceled'));
            else
                action.end();
            this.timedMetricActionsMap.delete(timedMetric.eventName);
            (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.FINISHED, timedMetric);
        }
        return !!action;
    }
    reportData(timedMetric, key, value) {
        (0, dynatraceReporter_1.logTimeMetricStatus)(this.logger, types_1.DynatraceTimeMetricStatus.REPORTED, timedMetric);
        const action = this.timedMetricActionsMap.get(timedMetric.eventName);
        if (action) {
            this.dynatraceSDK.addCustomRequestAttribute(key, value);
        }
        return !!action;
    }
    traceSQLDatabaseRequest(databaseInfo, startData) {
        return (0, dynatraceReporter_1.traceSQLDatabaseRequest)(this.dynatraceSDK, databaseInfo, startData);
    }
    traceIncomingRemoteCall(startData) {
        return (0, dynatraceReporter_1.traceIncomingRemoteCall)(this.dynatraceSDK, startData);
    }
    traceOutgoingRemoteCall(startData) {
        return (0, dynatraceReporter_1.traceOutgoingRemoteCall)(this.dynatraceSDK, startData);
    }
    traceIncomingMessage(startData) {
        return (0, dynatraceReporter_1.traceIncomingMessage)(this.dynatraceSDK, startData);
    }
    traceOutgoingMessage(startData) {
        return (0, dynatraceReporter_1.traceOutgoingMessage)(this.dynatraceSDK, startData);
    }
    getTraceContextInfo() {
        return (0, dynatraceReporter_1.getTraceContextInfo)(this.dynatraceSDK);
    }
    getCurrentState() {
        return (0, dynatraceReporter_1.getCurrentState)(this.dynatraceSDK);
    }
}
exports.default = ReporterDynatrace;
//# sourceMappingURL=dynatrace.js.map